/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-house': {
    width: 72,
    height: 72,
    viewBox: '0 0 72 72',
    data: '<path pid="0" d="M35.04 13.966a1.44 1.44 0 011.92 0l7.817 6.952V14.88c0-.53.43-.96.96-.96h5.213c.53 0 .96.43.96.96v12.374l6.328 5.626a.962.962 0 01-1.276 1.44l-3.202-2.849V57.12a1.44 1.44 0 01-1.44 1.44H19.68a1.44 1.44 0 01-1.44-1.44V31.471l-3.202 2.849a.962.962 0 11-1.276-1.44zm5.28 29.714h-8.64v12.96h8.64V43.68zm-4.32-28L20.16 29.76v26.88h10.56V43.68c0-.53.43-.96.96-.96h8.64c.53 0 .96.43.96.96v12.96h10.56V29.76L36 15.68zm0 10.583a5.11 5.11 0 110 10.22 5.11 5.11 0 010-10.22zm0 .96a4.15 4.15 0 100 8.3 4.15 4.15 0 000-8.3zM50.95 14.88h-5.213v6.888L50.95 26.4V14.88z" _fill="#005BA5" fill-rule="evenodd"/>'
  }
})
